/* eslint-disable default-case */
import React from "react";
import { Controller } from "react-hook-form";
import { InputAdornment, TextField } from "@material-ui/core";
import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import {
  DateFieldIcon,
  DownloadIconForForm,
  UploadFileButton,
} from "../libs/SVGIcons";
import { ITQChoices } from "../libs";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import InputMask from "react-input-mask";
import { FaTimes } from "react-icons/fa";

const turkishCharMap = {
  ç: "c",
  Ç: "c",
  ğ: "g",
  Ğ: "g",
  ı: "i",
  I: "i",
  İ: "i",
  ö: "o",
  Ö: "o",
  ş: "s",
  Ş: "s",
  ü: "u",
  Ü: "u",
};

export const normalize = (str) => {
  return str
    .normalize("NFD") // Decompose accents (like İ -> I + ̇)
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritic marks
    .split("")
    .map((char) => turkishCharMap[char] || char)
    .join("")
    .toLowerCase();
};

export const customFilter = (option, rawInput) => {
  console.log(option.label, rawInput);
  return normalize(option.label).includes(normalize(rawInput));
};

export const validationMessages = (error, fieldName = "This field", lang) => {
  if (error.type === "required") {
    return (
      window.sys_app_translate(fieldName, lang) +
      " " +
      window.sys_app_translate("is required", lang)
    );
  }
  if (error.type === "pattern") {
    switch (fieldName) {
      default:
        return (
          window.sys_app_translate(fieldName, lang) +
          " " +
          window.sys_app_translate("is not correct", lang)
        );
    }
  }
  if (error.type === "custom") {
    return error.message;
  }
  return error.message;
};
export const _getNormalInput = ({
  control,
  inputName,
  inputTitle,
  placeholder = null,
  inputId,
  errors,
  lang,
  type = "text",
  width = "col-4",
  inputSize = "small",
  required = true,
  preventNonLatinLetters = true,
  suffix = null,
  prefix = null,
  capitalize = true,
  disabled = false,
  rowsNumber = 10,
  onChange,
  customValidationRules = {},
}) => {
  let onKeyPress = () => {};
  let onKeyDown = () => {};

  switch (type) {
    case "number":
      onKeyPress = (e) => {
        if (
          (e.which != 8 && e.which != 0 && e.which < 48 && e.which !== 46) ||
          e.which > 57
        ) {
          e.preventDefault();
        }
      };
      onKeyDown = (e) => {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
        }
      };
      break;
    case "text":
      if (preventNonLatinLetters) {
        onKeyPress = window.preventNonLatinLetters;
      }
      break;
  }
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
          onChange: onChange,
          ...customValidationRules,
        }}
        render={({ field, fieldState }) => (
          <TextField
            id={inputId}
            size={inputSize}
            multiline={type === "textarea" ? true : false}
            type={type}
            rows={type === "textarea" ? rowsNumber : 1}
            onKeyPress={onKeyPress}
            onKeyDown={onKeyDown}
            className={
              capitalize
                ? "itqan-text-field itqan-text-field-capitalize"
                : "itqan-text-field"
            }
            label={window.sys_app_translate(inputTitle, lang)}
            variant="outlined"
            error={!!fieldState.error}
            helperText={
              fieldState.error &&
              validationMessages(fieldState.error, inputTitle)
            }
            InputProps={{
              startAdornment: prefix ? (
                <InputAdornment position="start">{prefix}</InputAdornment>
              ) : null,
              endAdornment: suffix ? (
                <InputAdornment position="end">{suffix}</InputAdornment>
              ) : null,
            }}
            disabled={disabled}
            placeholder={
              placeholder ? window.sys_app_translate(placeholder, lang) : null
            }
            {...field}
          />
        )}
      />
    </div>
  );
};

// const ValueContainer = ({ children, getValue, ...props }) => {
//   let maxToShow = 3;
//   var length = getValue().length;
//   let displayChips = React.Children.toArray(children).slice(0, maxToShow);
//   let shouldBadgeShow = length > maxToShow;
//   let displayLength = length - maxToShow;

//   return (
//     <components.ValueContainer {...props}>
//       {!props.selectProps.inputValue && displayChips}
//       <div className="root">
//         {shouldBadgeShow &&
//           `+ ${displayLength} item${length != 1 ? "s" : ""} selected`}
//       </div>
//     </components.ValueContainer>
//   );
// };

export const _getAsynSelect = ({
  control,
  inputId,
  inputName,
  options,
  errors,
  inputTitle,
  lang,
  multiple = false,
  width = "col-4",
  required = true,
  onChange = (e) => {},
  fetchOptions,
  defaultOptions = false,
  disabled = false,
  CustomMenuList = null,
  onAddClick = null,
  includeTitleInError = true,
}) => {
  console.log("gettig select input: " + inputName);
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
          onChange: onChange,
        }}
        render={({ field, fieldState }) => (
          <React.Fragment>
            <AsyncSelect
              id={inputId ?? "async-select"}
              className="itqan-react-select-field"
              cacheOptions
              loadOptions={(inputValue, callback) =>
                fetchOptions(inputValue, callback)
              }
              defaultOptions={defaultOptions}
              isMulti={multiple}
              isClearable={false}
              isDisabled={disabled}
              placeholder={window.sys_app_translate(inputTitle, lang)}
              components={{
                ...(CustomMenuList ? { MenuList: CustomMenuList } : {}),
              }}
              onAddClick={onAddClick}
              {...field}
            />
            {fieldState.error && (
              <div style={{ marginTop: "4px" }}>
                <p className="itqan-react-select-field-error">
                  {fieldState.error && includeTitleInError
                    ? validationMessages(fieldState.error, inputTitle)
                    : validationMessages(fieldState.error)}
                </p>
              </div>
            )}
          </React.Fragment>
        )}
      />
    </div>
  );
};

export const _getSelectInput = ({
  control,
  inputName,
  options,
  errors,
  inputTitle,
  lang,
  multiple = false,
  closeMenuOnSelect = true,
  width = "col-4",
  required = true,
  onChange = (e) => {},
  disabled = false,
  onAddClick = null,
  filterOption = null,
  includeTitleInError = true,
  customFilter,
  CustomMenuList = null,
}) => {
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
          onChange: onChange,
        }}
        render={({ field, fieldState }) => (
          <React.Fragment>
            <Select
              className="itqan-react-select-field"
              options={options}
              isMulti={multiple}
              isDisabled={disabled}
              placeholder={window.sys_app_translate(inputTitle, lang)}
              components={CustomMenuList ? { MenuList: CustomMenuList } : {}}
              onAddClick={onAddClick}
              filterOption={customFilter}
              closeMenuOnSelect={closeMenuOnSelect}
              {...field}
            />
            {fieldState.error && (
              <div style={{ marginTop: "4px" }}>
                <p className="itqan-react-select-field-error">
                  {fieldState.error && includeTitleInError
                    ? validationMessages(fieldState.error, inputTitle)
                    : validationMessages(fieldState.error)}
                </p>
              </div>
            )}
          </React.Fragment>
        )}
      />
    </div>
  );
};
export const _getDatePicker = ({
  control,
  inputName,
  inputTitle,
  errors,
  lang,
  width = "col-4",
  required = true,
}) => {
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
        }}
        render={({ field }) => (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              size="small"
              inputVariant="outlined"
              format="dd.MM.yyyy"
              className="itqan-date-field itqan-text-field"
              inputProps={{
                placeholder: window.sys_app_translate(inputTitle, lang),
              }}
              label={window.sys_app_translate(inputTitle, lang)}
              InputAdornmentProps={{ position: "end" }}
              keyboardIcon={<DateFieldIcon />}
              error={errors[inputName] ? true : false}
              helperText={
                errors[inputName] &&
                validationMessages(
                  errors[inputName],
                  window.sys_app_translate(inputTitle, lang)
                )
              }
              {...field}
            />
          </MuiPickersUtilsProvider>
        )}
      />
    </div>
  );
};
export const _getDateTimePicker = ({
  defaultValue = null,
  setValue,
  dateTimeName,
  required = true,
  lang = "en",
}) => {
  return (
    <Flatpickr
      className="e-daterange-picker"
      onChange={(dates) => {
        if (dates.length > 0) {
          setValue(
            dateTimeName,
            moment(dates[0]).format("YYYY-MM-DD HH:mm:ss")
          );
        }
      }}
      options={{
        mode: "single",
        enableTime: true,
        dateFormat: "Y-m-d h:i K",
        time_24hr: false,
        defaultDate: defaultValue,
      }}
      style={{
        height: "2rem",
        width: "100%",
        borderRadius: "8px",
        border: "1px solid #c9c9c9",
      }}
      placeholder={window.sys_app_translate("Date and Time", lang)}
      required={required}
    />
  );
};
export const _getPhoneInput = ({
  control,
  inputName,
  inputId,
  inputTitle,
  errors,
  lang,
  width = "col-4",
  required = true,
  placeholder = null,
  patternRegx = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/,
}) => {
  const onKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 43) {
      e.preventDefault();
    }
  };
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
          ...(required && {
            pattern: {
              value: patternRegx,
              message: "Invalid phone number",
            },
          }),
        }}
        render={({ field }) => (
          <>
            <InputMask
              mask="0 (999) 999 99 99"
              maskChar="_"
              disabled={false}
              {...field}
            >
              {(inputProps) => (
                <TextField
                  id={inputId}
                  size="small"
                  type="text"
                  className="itqan-text-field"
                  label={window.sys_app_translate(inputTitle, lang)}
                  variant="outlined"
                  error={!!errors[inputName]}
                  onKeyPress={onKeyPress}
                  helperText={
                    errors[inputName] &&
                    validationMessages(errors[inputName], inputTitle)
                  }
                  placeholder={
                    placeholder
                      ? window.sys_app_translate(placeholder, lang)
                      : null
                  }
                  {...field}
                />
              )}
            </InputMask>
          </>
        )}
      />
    </div>
  );
};
export const _getEmailInput = ({
  control,
  inputName,
  inputId,
  inputTitle,
  errors,
  lang,
  width = "col-4",
  required = true,
}) => {
  return (
    <div className={width}>
      <Controller
        name={inputName}
        control={control}
        rules={{
          required: required,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        }}
        render={({ field }) => (
          <TextField
            id={inputId}
            size="small"
            type="email"
            className="itqan-text-field itqan-text-field-capitalize"
            label={window.sys_app_translate(inputTitle, lang)}
            variant="outlined"
            error={!!errors[inputName]}
            helperText={
              errors[inputName] &&
              validationMessages(errors[inputName], inputTitle)
            }
            {...field}
          />
        )}
      />
    </div>
  );
};
export const _getCheckbox = ({
  inputName,
  inputTitle,
  inputId,
  isChecked,
  onChange,
  style,
  lang,
  width = "col-4",
  disabled = false,
}) => {
  return (
    <div className={width}>
      <div className="form-check" style={style}>
        <input
          className="form-check-input itqan-form-checkbox"
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          id={inputId}
          disabled={disabled}
        />
        <label className="form-check-label" htmlFor={inputId}>
          {window.sys_app_translate(inputTitle, lang)}
        </label>
      </div>
    </div>
  );
};
export const _getChoicesInput = ({
  inputTitle,
  activeItemId,
  choiceItems,
  onChosen,
  lang,
  width = "col-4",
}) => {
  return (
    <div className={width}>
      <ITQChoices
        title={window.sys_app_translate(inputTitle, lang) + ":"}
        activeItemId={activeItemId}
        items={choiceItems}
        onItemClick={(term) => {
          onChosen(term);
          return true;
        }}
        lang={lang}
      />
    </div>
  );
};
export const _getFileInput = ({
  register,
  inputName,
  inputTitle,
  inputId,
  errors,
  lang,
  width = "col-4",
  required = true,
  onChange = (e) => {},
}) => {
  return (
    <div className={width}>
      <label htmlFor="">
        {window.sys_app_translate(inputTitle, lang)}
        {register ? (
          <input
            type="file"
            id={inputId}
            required={required}
            className="form-control"
            accept="image/jpg"
            {...register(inputName, {
              required: false,
            })}
          />
        ) : (
          <input
            type="file"
            id={inputId}
            required={required}
            className="form-control"
            accept="image/jpg,image/png,application/pdf,image/jpeg"
            onChange={onChange}
          />
        )}
        {register ? (
          <span className="text-danger">
            {errors[inputName] &&
              validationMessages(errors[inputName], inputTitle)}
          </span>
        ) : null}
      </label>
    </div>
  );
};
export const _getPhotoInput = ({
  previewImage,
  inputName,
  inputTitle,
  inputDesc = "500px x 500px, Max size: 1 MB",
  lang,
  previewIdImage = () => {},
  errors,
  width = "col-4 offset-1 col-md-3 offset-md-0 col-lg-3 offset-lg-0",
  imageWidth,
  imageHeight,
}) => {
  let uploadFileInputRef = React.useRef(null);
  return (
    <div className={width}>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: imageWidth ?? "12.5rem",
          height: imageHeight ?? "12.5rem",
          backgroundColor: "white",
          borderRadius: "9px",
          border: "1px solid #E0E0E0",
          cursor: "pointer",
        }}
        onClick={() => {
          uploadFileInputRef.click();
        }}
      >
        {previewImage ? (
          <img
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "9px",
            }}
            src={
              typeof previewImage === "string" &&
              previewImage.includes("ippics")
                ? "https://itqansigorta.com/storage/" + previewImage
                : previewImage
            }
          />
        ) : (
          <div
            className="text-center"
            style={{ fontSize: "14px", color: "#434343" }}
          >
            <div>
              <UploadFileButton />
            </div>
            {window.sys_app_translate("upload " + inputTitle, lang)}
          </div>
        )}
      </div>
      <div
        style={{
          fontSize: "1.125rem",
          marginTop: "1.08rem",
          textAlign: "center",
          width: "12.5rem",
        }}
      >
        {window.sys_app_translate(inputTitle, lang)}
      </div>
      <input
        name={inputName}
        style={{ display: "none" }}
        type="file"
        ref={(input) => (uploadFileInputRef = input)}
        onChange={(e) => {
          previewIdImage(e.target.files[0]);
        }}
      />
      <div
        style={{
          fontSize: "11px",
          textAlign: "center",
          width: "12.5rem",
        }}
      >
        {inputDesc &&
          window.sys_app_translate("Image dimensions: " + inputDesc, lang)}
      </div>
      <div style={{ fontSize: "11px", color: "red" }}>
        {errors[inputName] &&
          validationMessages(
            errors[inputName],
            window.sys_app_translate(inputTitle, lang)
          )}
      </div>
    </div>
  );
};
export const _getSwitchInput = ({
  setValue = () => {},
  value,
  title,
  id,
  lang,
}) => {
  return (
    <div
      className="form-check form-switch switch-button"
      style={{ display: "flex", alignItems: "center" }}
    >
      <input
        className="form-check-input"
        type="checkbox"
        checked={value}
        onChange={async (e) => {
          setValue(e.target.checked);
        }}
        role="switch"
        id={id}
      />
      <label
        className="form-check-label inter inter-medium"
        style={{
          color: "#199B8B",
          marginRight: "18px",
          marginLeft: "6px",
          fontSize: "16px",
        }}
      >
        {window.sys_app_translate(title, lang)}
      </label>
    </div>
  );
};
